import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CandidatesJobsAlert } from '../../models/candidatesJobsAlert.model';
import { ActivatedRoute, Router } from '@angular/router';
import { FunctionsService } from 'src/app/services/functions.service';
import { UsersService } from '../../services/users.service';
import { Candidates } from '../../models/candidates.model';
import { Trainings } from '../../models/trainings.model';
import { Professions } from '../../models/professions.model';
import { HttpService } from '../../services/http.service';
import Swal from 'sweetalert2';
import { Jobs } from '../../models/jobs.model';
import { CandidatesEducationsAlert } from '../../models/candidatesEducationsAlert.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  baseURL = environment.apiUrl;
  candidates: Candidates = new Candidates([]);
  portailName: String = 'Candidats/Consultants';
  typeUser: any;
  totalFillingRate = 0;
  personalInfoRate = 0;
  profileRate = 0;
  experienceRate = 0;
  trainingRate = 0;
  languageRate = 0;
  skillRate = 0;
  jobAlertIsLoading: boolean = false;
  jobAlertForm: FormGroup = new FormGroup({});
  CandidatesJobsAlertList: CandidatesJobsAlert[] = [];
  trainingList: Trainings[] = [];
  professionList: Professions[] = [];
  jobList: Jobs[] = [];

  educationCategoriesList: any[] = [];
  educationAlertIsLoading: boolean = false;
  educationAlertForm: FormGroup = new FormGroup({});
  candidatesEducationsAlertList: CandidatesEducationsAlert[] = [];

  constructor(private router: Router, private route: ActivatedRoute, private formBuilder: FormBuilder, public functionsService: FunctionsService, private usersService: UsersService, private httpService: HttpService) {
    this.typeUser = this.route.snapshot.paramMap.get('typeUser');
    this.candidates = this.usersService.getCurrentUser();
    if ((usersService.getUserType() == 'candidat' && this.typeUser == 'entreprise') || (usersService.getUserType() == 'entreprise' && this.typeUser == 'candidat')) {
      this.router.navigate(['/']);
    }

    if (this.typeUser == 'candidat') {
      this.portailName = 'Candidats';
    } else if (this.typeUser == 'consultant') {
      this.portailName = 'Consultants';
    } else if (this.typeUser == 'entreprise') {
      this.portailName = 'Entreprise';
    } else {
      this.router.navigate(['/not-found']);
    }
    if (usersService.getUserType() == 'entreprise') {
      this.router.navigate(['/accueil/entreprise']);
    }
    this.candidates = this.usersService.getCurrentUser();
  }

  ngOnInit() {
    localStorage.removeItem('jobEditing');

    if (this.typeUser == 'candidat') {
      this.calculateTotalFillingRate();
      // console.log(this.totalFillingRate);
    }
    const jobList = this.candidates.getCandidatesSaveJobs();

    jobList.forEach(element => {
      const jobs = new Jobs(element);
      this.jobList.push(jobs);
    });
  }

  calculateTotalFillingRate() {

    if (this.candidates.getGender() !== null && this.candidates.getGender() !== '') {
      this.personalInfoRate = 20;
    } else {
      this.personalInfoRate = 0;
    }

    if (this.candidates.getCandidatesTrainings().length > 0) {
      this.trainingRate = 15;
    } else {
      this.trainingRate = 0;
    }

    if (this.candidates.getCandidatesLanguages().length > 0) {
      this.languageRate = 15;
    } else {
      this.languageRate = 0;
    }

    if (this.candidates.getCandidatesSkills().length > 0) {
      this.skillRate = 15;
    } else {
      this.skillRate = 0;
    }

    if (this.candidates.getCandidatesExperiences().length > 0) {
      this.experienceRate = 15;
    } else {
      this.experienceRate = 0;
    }

    this.totalFillingRate = this.personalInfoRate + this.profileRate + this.experienceRate + this.trainingRate + this.languageRate + this.skillRate;

    localStorage.setItem('totalFillingRate', JSON.stringify(this.totalFillingRate));
  }
  removeBackupJob(jobID: number) {
    Swal.fire({
      title: 'Souhaiter vous supprimer cette offre ?',
      showDenyButton: true,
      confirmButtonText: 'Oui',
      denyButtonText: `Non`,
      confirmButtonColor: '#28a745',
      denyButtonColor: 'dc3545'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire('Veuillez patientez...');
        this.httpService.removeBackupJob(jobID, this.candidates.getToken()).subscribe(
          (response: any) => {
            if (response.status == "success") {
              let data = response.data;
              localStorage.setItem('currentCandidate', JSON.stringify(data));
              Swal.fire({
                icon: 'success',
                title: 'Excellent !',
                text: 'Offre d\'emploi supprimée.',
              });
              this.candidates = this.usersService.getCurrentUser();
              const jobList = this.candidates.getCandidatesSaveJobs();
              this.jobList = [];
              jobList.forEach(element => {
                const jobs = new Jobs(element);
                this.jobList.push(jobs);
              });
            }
          },
          (error) => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Vérifier votre connexion puis réessayée.',
            })
          }
        );
      }
    })
  }

}
